// -----------------------------------------------------------------------------------------
// interface
// -----------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------
// enum
// -----------------------------------------------------------------------------------------
/**
 * 期間区分
 */
 export const PeriodDiv = {
  /** 先月 */
  LastMonth: '0',
  /** 先週 */
  LastWeek: '1',
  /** 昨日 */
  Yesterday: '2',
  /** 今日 */
  Today: '3',
  /** 明日 */
  Tomorrow: '4',
  /** 今週 */
  ThisWeek: '5',
  /** 来週 */
  NextWeek: '6',
  /** 今月 */
  ThisMonth: '7',
  /** 来月 */
  NextMonth: '8'
};

/**
 * 期間区分の配列情報
 */
export const PeriodDivArray: Array<{ value: string, text: string }> = [
  { value: PeriodDiv.LastMonth, text: '先月' },
  { value: PeriodDiv.LastWeek, text: '先週' },
  { value: PeriodDiv.Yesterday, text: '昨日' },
  { value: PeriodDiv.Today, text: '今日' },
  { value: PeriodDiv.Tomorrow, text: '明日' },
  { value: PeriodDiv.ThisWeek, text: '今週' },
  { value: PeriodDiv.NextWeek, text: '来週' },
  { value: PeriodDiv.ThisMonth, text: '今月' },
  { value: PeriodDiv.NextMonth, text: '来月' }
];

// -----------------------------------------------------------------------------------------
// const
// -----------------------------------------------------------------------------------------
/**
 * 実施内容グループ区分
 */
export const EXECUTE_CHECK_GROUP_DIV: { [key: string]: number } = {
  /** 車検 */
  VEHICLE_INSPECTION: 1,

  /** 点検 */
  INSPECTION: 2,

  /** その他 */
  OTHER: 3
};

/**
 * 実施内容グループリスト
 */
export const EXECUTE_CHECK_GROUP_LIST: { name: string, code: number }[] = [
  { code: EXECUTE_CHECK_GROUP_DIV.VEHICLE_INSPECTION, name: '車検' },
  { code: EXECUTE_CHECK_GROUP_DIV.INSPECTION, name: '点検' },
  { code: EXECUTE_CHECK_GROUP_DIV.OTHER, name: 'その他' }
];

/**
 * 自動生成履歴用の実施内容コードリスト
 */
export const AUTO_GENERATION_HISTORY_EXECUTE_ITEM_CODE_LIST = [90018, 90019, 90020, 90021, 90022, 90023, 90024];

/**
 * 除外コンタクト手段コード
 */
export const CONTACT_METHOD_CODE_IGNORE = 999999999;

/**
 * メッセージ定義
 */
export const CONTACT_MESSAGE = {
  /** 組織変更確認 */
  CONFIRM_CHANGE_ORGANIZATION: '組織を変更すると実施内容および実施手段の選択が初期化されます。\nよろしいですか？',
};

/**
 * イベントID
 */
 export const EVENT_ID = {
  /** 車両販売 */
  CAR_SALES: '8',

  /** タスク */
  TASK: '1001'
};



// WEBPACK FOOTER //
// ./src/app/shared/contact/contact-page.interface.ts